export const validateDeliveryAfterPickup = (pickupDateString, deliveryDateString, deliveryFieldName, errorsBag) => {
    const pickupDate = newSafeDate(pickupDateString);
    const deliveryDate = newSafeDate(deliveryDateString);
    if(pickupDate && deliveryDate && deliveryDate.getTime() < pickupDate.getTime()) {
      errorsBag.add({
          field: deliveryFieldName,
          msg: 'The delivery date must be after the pick up date.',
      });
    }
}

export const isArrayForTransferOrderEmpty = (su) => {
  return su.length == 0 || su.every(item => !item.description || 
    (Array.isArray(item.components) && item.components.length > 0 && item.components.every(comp => !comp.includeInTransferOrder)));
}


// WEBPACK FOOTER //
// ./src/utils/validation.js